var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHistory = function SvgHistory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.536 2.541A1.852 1.852 0 0 1 3.846 2h9.966a1.853 1.853 0 0 1 1.852 1.852v4.454a.75.75 0 1 1-1.5 0V3.851a.352.352 0 0 0-.352-.352H3.845a.352.352 0 0 0-.352.352v11.025a.353.353 0 0 0 .352.352H8.3a.75.75 0 0 1 0 1.5H3.845a1.852 1.852 0 0 1-1.852-1.852V3.85c0-.491.195-.962.543-1.31Zm2.397 3.882a.75.75 0 0 1 .75-.75h6.291a.75.75 0 0 1 0 1.5H5.683a.75.75 0 0 1-.75-.75Zm0 2.94a.75.75 0 0 1 .75-.75h2.94a.75.75 0 1 1 0 1.5h-2.94a.75.75 0 0 1-.75-.75Zm8.79.122a4.233 4.233 0 1 1 0 8.466 4.233 4.233 0 0 1 0-8.466Zm1.54 4.233h-1.54v-1.924a.385.385 0 0 0-.77 0V14.11c.004.21.175.378.386.378h1.924a.385.385 0 1 0 0-.77Z",
    fill: "#666"
  })));
};
export default SvgHistory;